export const SelectItems = (data) => {
    return data.map((item) => {
        item["color"] = "red";
        item["text"] = item["value"];
        return item;
    });
}